interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "default" | "invert";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "default",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const isInvert = tone === "invert";

  return (
    <div className={`${isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
      <div
        className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] ${
          isCenter ? "justify-center" : ""
        } ${isInvert ? "text-accent-400" : "text-primary-600"}`}
      >
        <span className={`h-px w-6 ${isInvert ? "bg-accent-400" : "bg-primary-500"}`} />
        {eyebrow}
      </div>
      <h2
        className={`mt-4 text-2xl leading-snug md:text-4xl font-heading font-bold ${
          isInvert ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            isInvert ? "text-background-200/80" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}